
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'glossary-usage-info-dialog-words-columns-list',
    props: {
        selectedWords: { type: Array, required: true },
        wordsList: { type: Array },
        columnList: { type: Array },
        columnField: { type: String }
    },
    data() {
        return {}
    },
    methods: {
        wordIsSelected(word: any) {
            return this.selectedWords.findIndex((el: any) => word.WORD_ID === el.WORD_ID) > -1
        }
    }
})
